import {
  GET_FORM_LABEL,
  FORM_LABEL_ERROR,
  GET_FORM_LABEL_BY_FORM
} from '../types'
import client from '../../lib/api-client'
import { API_FORM_LABEL } from '../../lib/constants'

export const getFormLabel = (query) => async (dispatch) => {
  const q = 'ewoicnV0Y2lhIjo5OTA2MTAwMCwKImlkZm9ybSI6IDMKfQ=='
  try {
    const res = await client.get(`${API_FORM_LABEL}?q=${q}`)
    dispatch({
      type: GET_FORM_LABEL,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: FORM_LABEL_ERROR,
      payload: console.log(e)
    })
  }
}

export const getFormLabelByForm = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_FORM_LABEL}?q=${q}`)
    dispatch({
      type: GET_FORM_LABEL_BY_FORM,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: FORM_LABEL_ERROR,
      payload: console.log(e)
    })
  }
}
